import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

export const JiraAppSelectorIcon = (): React.JSX.Element => {
	if (!fg('search_all_apps_icon_app_count')) {
		return <JiraAppSelectorIconOld />;
	}

	return (
		<svg width="52" height="16" viewBox="0 0 52 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_4313_48579)">
				<rect width="16" height="16" rx="4" fill="#1868DB" />
				<g clipPath="url(#clip1_4313_48579)">
					<path
						d="M11.5797 9.51003C9.1108 8.31624 8.38955 8.13786 7.34929 8.13786C6.12871 8.13786 5.08845 8.64556 4.15915 10.0726L4.00658 10.3059C3.88174 10.498 3.854 10.5666 3.854 10.6489C3.854 10.7313 3.89561 10.7999 4.04819 10.8959L5.61552 11.8702C5.69874 11.9251 5.76809 11.9525 5.83744 11.9525C5.92066 11.9525 5.97614 11.9113 6.05936 11.7878L6.30903 11.4036C6.69739 10.8136 7.04415 10.6215 7.48799 10.6215C7.87636 10.6215 8.33407 10.7313 8.90275 11.0057L10.5394 11.7741C10.7059 11.8564 10.8862 11.8153 10.9694 11.6232L11.7461 9.92168C11.8294 9.72958 11.7739 9.60608 11.5797 9.51003ZM4.38107 6.50497C6.84996 7.69876 7.57121 7.87714 8.61148 7.87714C9.83205 7.87714 10.8723 7.36944 11.8016 5.94238L11.9542 5.70911C12.079 5.517 12.1068 5.4484 12.1068 5.36607C12.1068 5.28373 12.0652 5.21513 11.9126 5.11907L10.3452 4.14483C10.262 4.08994 10.1927 4.0625 10.1233 4.0625C10.0401 4.0625 9.98462 4.10367 9.9014 4.22716L9.65174 4.61137C9.26338 5.2014 8.91662 5.39351 8.47277 5.39351C8.08441 5.39351 7.62669 5.28373 7.05802 5.0093L5.42133 4.24088C5.25489 4.15855 5.07458 4.19972 4.99136 4.39182L4.21463 6.09332C4.13141 6.28542 4.18689 6.40892 4.38107 6.50497Z"
						fill="white"
					/>
				</g>
			</g>
			<mask id="path-3-inside-1_4313_48579" fill="white">
				<path d="M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z" />
			</mask>
			<path
				d="M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z"
				fill="white"
			/>
			<path
				d="M22 0V1H30V0V-1H22V0ZM34 4H33V12H34H35V4H34ZM30 16V15H22V16V17H30V16ZM18 12H19V4H18H17V12H18ZM22 16V15C20.3431 15 19 13.6569 19 12H18H17C17 14.7614 19.2386 17 22 17V16ZM34 12H33C33 13.6569 31.6569 15 30 15V16V17C32.7614 17 35 14.7614 35 12H34ZM30 0V1C31.6569 1 33 2.34315 33 4H34H35C35 1.23858 32.7614 -1 30 -1V0ZM22 0V-1C19.2386 -1 17 1.23858 17 4H18H19C19 2.34315 20.3431 1 22 1V0Z"
				fill="#0B120E"
				fillOpacity="0.14"
				mask="url(#path-3-inside-1_4313_48579)"
			/>
			<g clipPath="url(#clip2_4313_48579)">
				<path
					d="M21.4724 11.3852L21.9428 12.1936C22.0406 12.3638 22.1811 12.4975 22.346 12.5947L24.0261 9.70166H20.666C20.666 9.89007 20.7149 10.0785 20.8126 10.2487L21.4724 11.3852Z"
					fill="#0066DA"
				/>
				<path
					d="M25.9993 6.29834L24.3193 3.40527C24.1544 3.50252 24.0139 3.63623 23.9161 3.80641L20.8126 9.15494C20.7167 9.32145 20.6661 9.51002 20.666 9.70195H24.0261L25.9993 6.29834Z"
					fill="#00AC47"
				/>
				<path
					d="M29.6534 12.5947C29.8184 12.4975 29.9589 12.3638 30.0566 12.1936L30.2521 11.8593L31.1868 10.2487C31.2846 10.0785 31.3335 9.89007 31.3335 9.70166H27.9731L28.6882 11.0996L29.6534 12.5947Z"
					fill="#EA4335"
				/>
				<path
					d="M25.9999 6.29821L27.6799 3.40515C27.5149 3.3079 27.3256 3.25928 27.1301 3.25928H24.8697C24.6742 3.25928 24.4848 3.31398 24.3198 3.40515L25.9999 6.29821Z"
					fill="#00832D"
				/>
				<path
					d="M27.9723 9.70166H24.0257L22.3457 12.5947C22.5107 12.692 22.7 12.7406 22.8955 12.7406H29.1025C29.298 12.7406 29.4874 12.6859 29.6523 12.5947L27.9723 9.70166Z"
					fill="#2684FC"
				/>
				<path
					d="M29.635 6.48068L28.0832 3.80641C27.9855 3.63623 27.845 3.50252 27.68 3.40527L26 6.29834L27.9733 9.70195H31.3272C31.3272 9.51353 31.2784 9.32512 31.1806 9.15494L29.635 6.48068Z"
					fill="#FFBA00"
				/>
			</g>
			<mask id="path-11-inside-2_4313_48579" fill="white">
				<path d="M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z" />
			</mask>
			<path
				d="M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z"
				fill="white"
			/>
			<path
				d="M40 0V1H48V0V-1H40V0ZM52 4H51V12H52H53V4H52ZM48 16V15H40V16V17H48V16ZM36 12H37V4H36H35V12H36ZM40 16V15C38.3431 15 37 13.6569 37 12H36H35C35 14.7614 37.2386 17 40 17V16ZM52 12H51C51 13.6569 49.6569 15 48 15V16V17C50.7614 17 53 14.7614 53 12H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM40 0V-1C37.2386 -1 35 1.23858 35 4H36H37C37 2.34315 38.3431 1 40 1V0Z"
				fill="#0B120E"
				fillOpacity="0.14"
				mask="url(#path-11-inside-2_4313_48579)"
			/>
			<g clipPath="url(#clip3_4313_48579)">
				<path
					d="M41.1422 9.29914C41.1422 9.87394 40.6776 10.3385 40.1028 10.3385C39.528 10.3385 39.0635 9.87394 39.0635 9.29914C39.0635 8.72433 39.528 8.25977 40.1028 8.25977C40.6769 8.25977 41.1422 8.72511 41.1422 9.29914ZM41.6619 9.29914C41.6619 8.72433 42.1265 8.25977 42.7013 8.25977C43.2761 8.25977 43.7406 8.72433 43.7406 9.29914V11.8976C43.7406 12.4724 43.2761 12.9369 42.7013 12.9369C42.1265 12.9369 41.6619 12.4724 41.6619 11.8976V9.29914Z"
					fill="#E01E5A"
				/>
				<path
					d="M42.7013 5.1261C42.1265 5.1261 41.662 4.66154 41.662 4.08673C41.662 3.51193 42.1265 3.04736 42.7013 3.04736C43.2761 3.04736 43.7407 3.51193 43.7407 4.08673C43.7407 4.66076 43.2754 5.1261 42.7013 5.1261ZM42.7013 5.65366C43.2761 5.65366 43.7407 6.11823 43.7407 6.69303C43.7407 7.26784 43.2761 7.7324 42.7013 7.7324H40.095C39.5202 7.7324 39.0557 7.26784 39.0557 6.69303C39.0557 6.11823 39.5202 5.65366 40.095 5.65366H42.7013Z"
					fill="#36C5F0"
				/>
				<path
					d="M46.8665 6.69303C46.8665 6.11823 47.3311 5.65366 47.9059 5.65366C48.4807 5.65366 48.9452 6.11823 48.9452 6.69303C48.9452 7.26784 48.4807 7.7324 47.9059 7.7324H46.8665V6.69303ZM46.3468 6.69303C46.3468 7.26784 45.8822 7.7324 45.3074 7.7324C44.7326 7.7324 44.2681 7.26784 44.2681 6.69303V4.08673C44.2681 3.51193 44.7326 3.04736 45.3074 3.04736C45.8822 3.04736 46.3468 3.51193 46.3468 4.08673V6.69303Z"
					fill="#2EB67D"
				/>
				<path
					d="M45.3074 10.8582C45.8822 10.8582 46.3468 11.3228 46.3468 11.8976C46.3468 12.4724 45.8822 12.9369 45.3074 12.9369C44.7326 12.9369 44.2681 12.4724 44.2681 11.8976V10.8582H45.3074ZM45.3074 10.3385C44.7326 10.3385 44.2681 9.87394 44.2681 9.29914C44.2681 8.72433 44.7326 8.25977 45.3074 8.25977H47.9137C48.4885 8.25977 48.9531 8.72433 48.9531 9.29914C48.9531 9.87394 48.4885 10.3385 47.9137 10.3385H45.3074Z"
					fill="#ECB22E"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4313_48579">
					<rect width="16" height="16" fill="white" />
				</clipPath>
				<clipPath id="clip1_4313_48579">
					<rect width="8.25276" height="7.89" fill="white" transform="translate(3.854 4.0625)" />
				</clipPath>
				<clipPath id="clip2_4313_48579">
					<rect
						width="10.6667"
						height="9.48148"
						fill="white"
						transform="translate(20.666 3.25928)"
					/>
				</clipPath>
				<clipPath id="clip3_4313_48579">
					<rect width="10" height="10" fill="white" transform="translate(39 3)" />
				</clipPath>
			</defs>
		</svg>
	);
};

const JiraAppSelectorIconOld = (): React.JSX.Element => (
	<svg
		role="presentation"
		width="42"
		height="16"
		viewBox="0 0 42 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask id="path-1-inside-1_411_4616" fill="white">
			<path d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z" />
		</mask>
		<path
			d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z"
			fill="white"
		/>
		<path
			d="M30 0V1H38V0V-1H30V0ZM42 4H41V12H42H43V4H42ZM38 16V15H30V16V17H38V16ZM26 12H27V4H26H25V12H26ZM30 16V15C28.3431 15 27 13.6569 27 12H26H25C25 14.7614 27.2386 17 30 17V16ZM42 12H41C41 13.6569 39.6569 15 38 15V16V17C40.7614 17 43 14.7614 43 12H42ZM38 0V1C39.6569 1 41 2.34315 41 4H42H43C43 1.23858 40.7614 -1 38 -1V0ZM30 0V-1C27.2386 -1 25 1.23858 25 4H26H27C27 2.34315 28.3431 1 30 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-1-inside-1_411_4616)"
		/>
		<g clipPath="url(#clip0_411_4616)">
			<path
				d="M31.1422 9.29926C31.1422 9.87406 30.6777 10.3386 30.1029 10.3386C29.5281 10.3386 29.0635 9.87406 29.0635 9.29926C29.0635 8.72445 29.5281 8.25989 30.1029 8.25989H31.1422V9.29926ZM31.6619 9.29926C31.6619 8.72445 32.1265 8.25989 32.7013 8.25989C33.2761 8.25989 33.7407 8.72445 33.7407 9.29926V11.8977C33.7407 12.4725 33.2761 12.9371 32.7013 12.9371C32.1265 12.9371 31.6619 12.4725 31.6619 11.8977V9.29926Z"
				fill="#E01E5A"
			/>
			<path
				d="M32.7014 5.12598C32.1266 5.12598 31.662 4.66141 31.662 4.08661C31.662 3.51181 32.1266 3.04724 32.7014 3.04724C33.2762 3.04724 33.7408 3.51181 33.7408 4.08661V5.12598H32.7014ZM32.7014 5.65354C33.2762 5.65354 33.7408 6.11811 33.7408 6.69291C33.7408 7.26771 33.2762 7.73228 32.7014 7.73228H30.0951C29.5203 7.73228 29.0557 7.26771 29.0557 6.69291C29.0557 6.11811 29.5203 5.65354 30.0951 5.65354H32.7014Z"
				fill="#36C5F0"
			/>
			<path
				d="M36.8666 6.69291C36.8666 6.11811 37.3311 5.65354 37.9059 5.65354C38.4807 5.65354 38.9453 6.11811 38.9453 6.69291C38.9453 7.26771 38.4807 7.73228 37.9059 7.73228H36.8666V6.69291ZM36.3469 6.69291C36.3469 7.26771 35.8823 7.73228 35.3075 7.73228C34.7327 7.73228 34.2681 7.26771 34.2681 6.69291V4.08661C34.2681 3.51181 34.7327 3.04724 35.3075 3.04724C35.8823 3.04724 36.3469 3.51181 36.3469 4.08661V6.69291Z"
				fill="#2EB67D"
			/>
			<path
				d="M35.3075 10.8583C35.8823 10.8583 36.3469 11.3229 36.3469 11.8977C36.3469 12.4725 35.8823 12.9371 35.3075 12.9371C34.7327 12.9371 34.2681 12.4725 34.2681 11.8977V10.8583H35.3075ZM35.3075 10.3386C34.7327 10.3386 34.2681 9.87406 34.2681 9.29926C34.2681 8.72445 34.7327 8.25989 35.3075 8.25989H37.9138C38.4886 8.25989 38.9532 8.72445 38.9532 9.29926C38.9532 9.87406 38.4886 10.3386 37.9138 10.3386H35.3075Z"
				fill="#ECB22E"
			/>
		</g>
		<mask id="path-7-inside-2_411_4616" fill="white">
			<path d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z" />
		</mask>
		<path
			d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z"
			fill="white"
		/>
		<path
			d="M17 0V1H25V0V-1H17V0ZM29 4H28V12H29H30V4H29ZM25 16V15H17V16V17H25V16ZM13 12H14V4H13H12V12H13ZM17 16V15C15.3431 15 14 13.6569 14 12H13H12C12 14.7614 14.2386 17 17 17V16ZM29 12H28C28 13.6569 26.6569 15 25 15V16V17C27.7614 17 30 14.7614 30 12H29ZM25 0V1C26.6569 1 28 2.34315 28 4H29H30C30 1.23858 27.7614 -1 25 -1V0ZM17 0V-1C14.2386 -1 12 1.23858 12 4H13H14C14 2.34315 15.3431 1 17 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-7-inside-2_411_4616)"
		/>
		<g clipPath="url(#clip1_411_4616)">
			<path
				d="M16.4728 11.3856L16.9432 12.194C17.041 12.3641 17.1815 12.4978 17.3464 12.5951L19.0264 9.70203H15.6664C15.6664 9.89044 15.7153 10.0789 15.813 10.249L16.4728 11.3856Z"
				fill="#0066DA"
			/>
			<path
				d="M20.9997 6.29834L19.3197 3.40527C19.1547 3.50252 19.0142 3.63623 18.9165 3.80641L15.813 9.15494C15.7171 9.32145 15.6665 9.51002 15.6664 9.70195H19.0264L20.9997 6.29834Z"
				fill="#00AC47"
			/>
			<path
				d="M24.6534 12.5951C24.8183 12.4978 24.9588 12.3641 25.0566 12.194L25.2521 11.8597L26.1868 10.249C26.2845 10.0789 26.3334 9.89044 26.3334 9.70203H22.9731L23.6881 11.0999L24.6534 12.5951Z"
				fill="#EA4335"
			/>
			<path
				d="M21 6.29846L22.68 3.40539C22.5151 3.30814 22.3257 3.25952 22.1302 3.25952H19.8698C19.6743 3.25952 19.4849 3.31422 19.3199 3.40539L21 6.29846Z"
				fill="#00832D"
			/>
			<path
				d="M22.9727 9.70203H19.0262L17.3461 12.5951C17.5111 12.6923 17.7005 12.741 17.896 12.741H24.1029C24.2984 12.741 24.4878 12.6863 24.6527 12.5951L22.9727 9.70203Z"
				fill="#2684FC"
			/>
			<path
				d="M24.6352 6.48068L23.0834 3.80641C22.9857 3.63623 22.8452 3.50252 22.6802 3.40527L21.0002 6.29834L22.9735 9.70195H26.3274C26.3274 9.51353 26.2785 9.32512 26.1808 9.15494L24.6352 6.48068Z"
				fill="#FFBA00"
			/>
		</g>
		<mask
			id="path-15-outside-3_411_4616"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="17"
			height="16"
			fill="black"
		>
			<rect fill="white" width="17" height="16" />
			<path d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z" />
		</mask>
		<path
			d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
			fill="#1868DB"
		/>
		<path
			d="M0 0H16H0ZM16 16H0H16ZM0 16V0V16ZM12 0C14.7614 0 17 2.23858 17 5V11C17 13.7614 14.7614 16 12 16C13.6569 16 15 14.2091 15 12V4C15 1.79086 13.6569 0 12 0Z"
			fill="white"
			mask="url(#path-15-outside-3_411_4616)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.27268 4.29895C4.09939 4.66482 3.85618 5.18269 3.73216 5.44985L3.50662 5.93552L5.01882 6.65669C6.97255 7.58839 7.08061 7.633 7.68635 7.75812C8.31815 7.88863 8.64861 7.88918 9.25981 7.76092C10.3578 7.5304 11.3469 6.79524 12.0927 5.6556C12.3169 5.31299 12.5002 5.0019 12.5 4.96425C12.4994 4.85707 10.3872 3.6037 10.3256 3.67404C10.2956 3.70815 10.1268 3.95702 9.95035 4.22698C9.44872 4.99447 9.04484 5.27117 8.42628 5.27104C8.15087 5.27097 7.83125 5.14353 6.37424 4.45238C5.42508 4.00219 4.6348 3.63379 4.61808 3.63379C4.60137 3.63379 4.44589 3.93308 4.27268 4.29895ZM6.72033 8.23492C5.59365 8.49191 4.59086 9.30041 3.78223 10.6039L3.5 11.0588L3.8216 11.2616C4.74354 11.8429 5.62033 12.3661 5.67224 12.3661C5.70444 12.3661 5.85508 12.1571 6.0068 11.9016C6.33222 11.3539 6.78153 10.917 7.1416 10.7981C7.6388 10.6341 7.94927 10.7271 9.71921 11.5709C10.6367 12.0083 11.4023 12.3661 11.4205 12.3661C11.5023 12.3661 12.5181 10.1057 12.4608 10.0515C12.3259 9.92395 9.19029 8.47199 8.76043 8.33801C8.17024 8.15401 7.27374 8.10871 6.72033 8.23492Z"
			fill="white"
		/>
		<defs>
			<clipPath id="clip0_411_4616">
				<rect width="10" height="10" fill="white" transform="translate(29.0002 3)" />
			</clipPath>
			<clipPath id="clip1_411_4616">
				<rect width="10.6667" height="9.48148" fill="white" transform="translate(15.6662 3.2594)" />
			</clipPath>
		</defs>
	</svg>
);
